import React from 'react';
import { Base64 } from 'js-base64';
import { FormattedMessage } from 'react-intl';
import { Button, Icon, Input } from 'antd';

class SysConfig extends React.Component {
  // let hostUrl = String(window.location.href).toLowerCase();

  constructor(props) {
    super(props);
    this.state = {
      domainName: '',
      password: ''
    };
  }

  render() {
    const { intl, dispatch } = this.props;
    const { domainName, password } = this.state;

    return (
      <div className="sys-config-page">
        <div className="domain-login-div">
          <Input
            placeholder="请输入域名"
            prefix={<Icon type="global" style={{ color: 'rgba(0,0,0,.3)' }} />}
            value={domainName}
            onChange={e => this.setState({ domainName: e.target.value })}
          />
          <Input
            type="password"
            placeholder="请输入密码"
            prefix={
              <Icon
                type="lock"
                style={{ color: 'rgba(0,0,0,.3)', fontSize: '18px' }}
              />
            }
            value={Base64.decode(password)}
            onChange={e =>
              this.setState({ password: Base64.encode(e.target.value) })
            }
          />
          <Button
            type="primary"
            disabled={domainName === '' || password === ''}
            onClick={e => {
              e.stopPropagation();
              dispatch({
                type: 'login/loginByDomain',
                domain: domainName,
                password: Base64.decode(password)
              });
            }}
          >
            <FormattedMessage id="index_login" />
          </Button>
        </div>
      </div>
    );
  }
}

export default SysConfig;



// WEBPACK FOOTER //
// ./src/components/login/SysConfig.js